import React, { Component } from "react";
import { FiChevronDown, FiChevronRight, FiShare2 } from "react-icons/fi";
import { Link, Redirect } from "react-router-dom";
import Image from "../../../base/features/micro/Image";
import Spinner from "../../../base/features/micro/Spinner";
import { Modal, ModalBody } from "reactstrap";
import checkLength from "../../../base/utils/check_length";
import { RWebShare } from "react-web-share";
import { showBackButtonInShop } from "../../../settings/appConfig";

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
      otherShopsModal: false,
    };
  }
  setShop() {
    localStorage.setItem(
      `selected_shop`,
      JSON.stringify(this.props.shopProperties)
    );
    window.location.href = `/dashboard/${this.props.shopProperties.uid}`;
  }
  get hasOtherShops() {
    return (
      this.props.shopProperties.other_shops &&
      this.props.shopProperties.other_shops.length > 0
    );
  }
  get is_owner() {
    return this.props.shopProperties.is_owner;
  }
  get showMoreShopsButton() {
    return this.hasOtherShops || this.is_owner;
  }
  get showBackButton() {
    return showBackButtonInShop;
  }

  render() {
    if (this.state.redirect) {
      return <Redirect push to={"/"} />;
    }
    return (
      <header style={{ zIndex: "4" }}>
        <div
          className="row mx-0 position-fixed bg-white px-4 py-2-3"
          style={{ top: "0", right: "0", left: "0", zIndex: "9999999" }}
        >
          {this.showBackButton && (
            <div
              className="col-auto align-self-center px-0"
              onClick={() =>
                window.history.length > 2
                  ? window.history.back()
                  : this.setState({ redirect: true })
              }
            >
              <FiChevronRight size="30" />
            </div>
          )}
          <div className="col-auto align-self-center px-2">
            <Image
              imageUri={
                this.props.shopProperties &&
                this.props.shopProperties.cover &&
                this.props.shopProperties.cover.file
              }
              imgClassName={"img-cover rounded-circle"}
              imageHeight={"35"}
              imageWidth={"35"}
              extraClassName={"rounded-circle bg-color-main p-2"}
            />
          </div>
          {this.props.shopProperties && (
            <div className="col align-self-center px-0">
              <span onClick={() => this.setState({ otherShopsModal: true })}>
                <span className="fw-bold fs-6 align-bottom">
                  {checkLength(this.props.shopProperties.title, 22)}
                </span>
                {this.props.shopProperties.is_verify && (
                  <img
                    width="15"
                    className="me-1"
                    alt="verify"
                    src={
                      require("../../../base/assets/icons/verify.svg").default
                    }
                  />
                )}
                {this.showMoreShopsButton && (
                  <FiChevronDown className="me-2" size={24} />
                )}
              </span>
            </div>
          )}
          <div className="col-auto align-self-center px-0">
            <RWebShare
              data={{
                text: this.state.shop_uid,
                url: window.location.href,
                title: "Gity market",
              }}
              onClick={() => console.log("shared successfully!")}
            >
              <FiShare2 size={24} />
            </RWebShare>
          </div>
        </div>
        <Modal
          dir="rtl"
          zIndex="9999999"
          className="m-0"
          contentClassName="border-0 position-fixed fixed-bottom rounded-top-28 w-auto max-h-75"
          isOpen={this.state.otherShopsModal}
          toggle={() =>
            this.setState({ otherShopsModal: !this.state.otherShopsModal })
          }
        >
          <ModalBody className="row mx-0 px-4 py-3">
            <div className="col-12 px-0">
              <p className="fw-bold fs-5">فروشگاه ها</p>
            </div>
            {this.props.shopProperties ? (
              <section>
                <div
                  className="col-12 px-0 py-2"
                  onClick={() => this.setState({ otherShopsModal: false })}
                >
                  <div className="row mx-0">
                    <div className="col-2 px-0 align-self-center">
                      <Image
                        imageHeight={"50"}
                        imageWidth={"50"}
                        extraClassName={"p-0 img-contain"}
                        imgClassName={"rounded-circle img-cover"}
                        isProfile={true}
                        imageUri={
                          this.props.shopProperties.cover &&
                          this.props.shopProperties.cover.thumbnail
                        }
                      />
                    </div>
                    <div className="col px-1 align-self-center">
                      <p className="mb-0 fw-bold fs-6">
                        {checkLength(this.props.shopProperties.title, 25)}
                      </p>
                    </div>
                  </div>
                </div>
                {this.props.shopProperties.other_shops.map((shop, s) => (
                  <Link to={`/${shop.uid}`}>
                    <div
                      className="col-12 px-0 py-2"
                      onClick={() => {
                        this.props.refresh(shop.uid);
                        this.setState({ otherShopsModal: false });
                      }}
                    >
                      <div className="row mx-0">
                        <div className="col-2 px-0 align-self-center">
                          <Image
                            imageHeight={"50"}
                            imageWidth={"50"}
                            extraClassName={"rounded-circle p-2 bg-color-main"}
                            imgClassName={"rounded-circle img-cover"}
                            imageUri={shop.cover && shop.cover.thumbnail}
                          />
                        </div>
                        <div className="col px-1 align-self-center">
                          <p className="mb-0 fw-bold fs-6">
                            {checkLength(shop.title, 30)}
                          </p>
                        </div>
                      </div>
                    </div>
                  </Link>
                ))}
                {this.is_owner && (
                  <p
                    className="py-2-3 text-center color-main fw-bold fs-5"
                    onClick={() => this.setShop()}
                  >
                    مدیریت فروشگاه
                  </p>
                )}
              </section>
            ) : (
              <Spinner />
            )}
          </ModalBody>
        </Modal>
      </header>
    );
  }
}

export default Header;
